<template v-if="links">
  <div class="owc-header-navigation-link-list">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <h3 v-if="headline" class="owc-header-navigation-link-list__headline">{{ headline }}</h3>
    <!--FIXME: Missing link list aria label-->
    <ul aria-label="">
      <li
        class="owc-header-navigation-link-list__linkOut"
        v-for="link in links"
        :key="link.label"
        role="none"
      >
        <a
          class="owc-header-navigation-link-list__linkOutAnchor"
          :href="link.url"
          :target="link.target"
          @click="handleLinkClick(link)"
          data-track="false"
          role="menuitem"
        >
          {{ link.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import {
  HeaderNavigationLinkListComponent,
  HeaderNavigationLinkListComputed,
  HeaderNavigationLinkListMethods,
  HeaderNavigationLinkListData,
  HeaderNavigationLinkListProps,
} from '@owc-packages/Header/src/HeaderNavigationLinkList';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import headerMixin from '@owc-utils/Mixins/Header';
import headerListMixin from '@owc-utils/Mixins/HeaderListMixin';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as HeaderNavigationLinkListComponent).extend<
  HeaderNavigationLinkListData,
  HeaderNavigationLinkListMethods,
  HeaderNavigationLinkListComputed,
  HeaderNavigationLinkListProps
>({
  name: 'owc-header-navigation-link-list',
  components: {
    ValidationBoxWrapper,
  },
  mixins: [headerMixin, headerListMixin, OwcDataComponent],
});
</script>

<style lang="scss">
@import '@owc-styles/utils';
@import './styles/flyout-vars';

.owc-header-navigation-link-list {
  @include breakpoint-to(mq4) {
    @include wb-content-width;
  }

  margin: 0 auto $flyout-spacing auto;

  color: var(--wb-grey-20);

  &__headline {
    @include wb-type-copy-secondary;

    margin-bottom: $flyout-spacing-small;

    @include breakpoint-from(mq3) {
      color: var(--wb-grey-45);
    }
    @include breakpoint-from(mq5) {
      @include wb-type-copy;
    }
  }
  &__linkOut {
    @include wb-type-copy;

    display: flex;
    align-items: center;

    min-height: $button-clickable-area--small;
    margin-bottom: $flyout-spacing-small;

    &:last-child {
      margin-bottom: 0;
    }
  }
  &__linkOutAnchor {
    color: inherit;

    text-decoration: none;
  }
}
</style>
